<template>
    <QuickpayPaymentLayout @back="$emit('back')">
        <template #description>
            <QuickpayPaymentOverviewDescription
                type="payment_success"
                :data="data"
                class="quickpay-payment-overview-success__description"
            />
        </template>
        <template #main-content>
            <div class="quickpay-payment-overview-success__ticket">
                <QuickpayPaymentTicket :data="data" @back="$emit('back')" />
            </div>
        </template>
    </QuickpayPaymentLayout>
</template>

<script>
import QuickpayPaymentLayout from 'vcomponents/quickpay/payment/QuickpayPaymentLayout.vue';
import QuickpayPaymentOverviewDescription from 'vcomponents/quickpay/payment/QuickpayPaymentOverviewDescription.vue';
import QuickpayPaymentTicket from 'vcomponents/quickpay/payment/QuickpayPaymentTicket.vue';

export default {
    components: {
        QuickpayPaymentLayout,
        QuickpayPaymentOverviewDescription,
        QuickpayPaymentTicket,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.quickpay-payment-overview-success {
    &__description {
        max-width: 260px;

        @media (max-width: 1023px) {
            max-width: 448px;
            width: 100%;
        }
    }

    &__ticket {
        max-width: 500px;
        filter: drop-shadow(0 1px 2px rgba(16, 24, 40, 0.06))
            drop-shadow(0 1px 3px rgba(16, 24, 40, 0.1));

        @media (max-width: 1023px) {
            max-width: 448px;
            width: 100%;
        }
    }
}
</style>
